import controller from './event-detail.controller';
import templateBase from './views/event-detail.view.html';
import templateAD from './views/event-detail.adaptative.html';

let EventDetailComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<',
    eventId: '@'
  }
};

function changeTemplate() {
  if(__env.adaptative){
    return templateAD;
  } else {
    return templateBase;
  }
}

export default EventDetailComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/events/event-detail/event-detail.component.js
 **/